import React from "react";

interface ArrowsIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const ArrowsIcon: React.FC<ArrowsIconProps> = (props) => {
  return (
    <svg
      width={props.width ?? "25"}
      height={props.height ?? "25"}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        fill={props.fill || "white"}
        d="M22.882 10.91h.302l-.214-.213-2.847-2.848a1.072 1.072 0 0 1 0-1.556 1.072 1.072 0 0 1 1.557 0l4.951 4.952c.339.338.444.777.224 1.217l-.006.012-.003.014c-.105.418-.53.648-.993.648H8.523c-.343 0-.62-.114-.81-.304-.19-.19-.303-.466-.303-.81 0-.342.114-.618.304-.808.19-.19.466-.304.809-.304h14.359zM6.542 18.087h-.301l.213.213 2.847 2.848c.446.446.446 1.11 0 1.556a1.163 1.163 0 0 1-.35.252 1.03 1.03 0 0 1-.428.082 1.03 1.03 0 0 1-.429-.082 1.163 1.163 0 0 1-.35-.252l-4.95-4.952c-.34-.338-.445-.777-.225-1.217.117-.233.258-.4.422-.509a1.02 1.02 0 0 1 .58-.165h17.33c.343 0 .62.114.81.304.19.19.303.466.303.81 0 .342-.113.618-.303.808-.19.19-.467.304-.81.304H6.542z"
        stroke={props.fill || "white"}
        stroke-width=".25"
      />
    </svg>
  );
};

export default ArrowsIcon;
